import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import footerImg from '../i/footer-bg.png';
import Logo from '../i/logo.png';
import Icon from '../i/Comcast_555_Logo_SigComm_final_3.svg';

const styles = {
  footer: {
    background: 'linear-gradient( 90deg, #182831 0%, #334956 100%)',
    height: '384px',
    position: 'relative',
    backgroundSize: 'cover',
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: '1',
      backgroundColor: '#334956',
      left: '0',
      top: '0',
    },
  },
  footerInner: {
    position: 'relative',
    zIndex: '10',
    top: '40px',
  },
  footerLogo: {
    display: 'table',
    padding: '56px 0 38px 0',
    margin: 'auto',
  },
  footLogo: {
    width: '200px',
    height: '200px',
    position: 'absolute',
    left: '50%',
    top: '-29%',
    transform: 'translateX(-50%)',
  },
  logoTxt: {
    fontSize: '23px',
    fontWeight: 500,
    color: '#fff',
    position: 'relative',
    top: '50px',
  },
  navItems: {
    display: 'table',
    margin: '38px auto 0 auto',
  },
  navList: {
    float: 'left',
    margin: '0 50px 0 0',
    listStyle: 'none',
  },
  navItemLink: {
    fontSize: '13px',
    color: 'rgba(255, 255, 255, 0.729)',
    textDecoration: 'none',
  },
  copyrights: {
    backgroundColor: 'rgba(0, 12, 26, 0.42)',
    lineHeight: '53px',
    position: 'absolute',
    width: '100%',
    zIndex: '10',
    textAlign: 'center',
    color: 'rgba(253, 253, 253, 0.851)',
    fontSize: '14px',
    bottom: '0',
  },
};
const copyRightsNavMenus = [
  // {
  //   label: 'Documentation',
  //   link: `${config.baseUrl555}/docs/doc1`,
  // },
  // {
  //   label: 'Blog',
  //   link: `${config.baseUrl555}/blog`,
  // },
];
const FooterSection = ({ classes }) => (
  <footer className={classes.footer}>
    <div className={classes.footerInner}>
      <span>
        <img className={classes.footLogo} src={Icon} alt="logo" />
      </span>
      <div className={classes.footerLogo}>
        <span className={classes.logoTxt}>Developer Portal</span>
      </div>
      <ul className={classes.navItems}>
        {copyRightsNavMenus.map(menu => (
          <li className={classes.navList} key={Math.random()}>
            <a href={menu.link} className={classes.navItemLink}>
              {menu.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  </footer>
);

export default withStyles(styles)(FooterSection);

FooterSection.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

FooterSection.defaultProps = {
  classes: {},
};
